import { featureAtom } from "@sunrise/feature-flags";

export const searchHistoryFeatureAtom = featureAtom("search-history", false, {
  description: "Show search history",
});
